import { useCallback } from 'react';
import useSWR from 'swr';

import { useConfiguration } from '../contexts';
import { getToken } from '../utils';

export const useToken = () => {
  const { customerId, identityUrl, tenant } = useConfiguration();
  const fetcher = useCallback(
    async () =>
      getToken({
        customerId,
        identityUrl,
        tenant,
      }),
    [customerId, identityUrl, tenant],
  );
  const { data } = useSWR('token', fetcher);

  return data;
};
